/**
 * EdInputPop组件悬浮属性
 */
export const PopverProps = {
  // 触发方式  click/focus/hover/manual
  trigger: {type: String, default: "manual"},
  // 标题
  title: {type: String, default: ""},
  // 显示的内容，也可以通过 slot 传入 DOM
  content: {type: String, default: ""},
  // 宽度
  width: {type: Number, default: 300},
  // 出现位置 top/top-start/top-end/bottom/bottom-start/bottom-end/left/left-start/left-end/right/right-start/right-end
  placement: {type: String, default: "left-start"},
  // Popover 是否可用
  disabled: {type: Boolean, default: false},
  // 出现位置的偏移量
  offset: {type: Number, default: 0},
  // 定义渐变动画
  transition: {type: String, default: 'fade-in-linear'},
  // 是否显示 Tooltip 箭头，更多参数可见Vue-popper
  visibleArrow: {type: Boolean, default: true},
  // popper.js 的参数
  popperOptions: {type: Object, default: () => {}},
  // 为 popper 添加类名
  popperClass: {type: String, default: ''},
  // 触发方式为 hover 时的显示延迟，单位为毫秒
  openDelay: {type: Number},
  // 触发方式为 hover 时的隐藏延迟，单位为毫秒
  closeDelay: {type: Number, default: 200},
  // Popover 组件的 tabindex
  tabindex: {type: Number, default: 0}
}


/**
 * EdInputPop组件属性
 */
export default {
  // 值
  value: {type: String, default: ""},
  height: {type: Number, default: 200,},
  placeholder: {type: String, default: ""},
  // 尺寸 medium / small / mini
  size: {type: String},

  ...PopverProps
}
